import type { TypeSelectOption } from '@thefarmersfront/kitchen';

/**
 * 객체를 Select 컴포넌트의 옵션 형식으로 변환하는 함수
 * @param option - 변환할 객체
 * @param valueKey - value로 사용할 키 이름
 * @param textKey - text로 사용할 키 이름
 * @param textFormatter - text 형식 변환 함수
 * @returns Select 컴포넌트에서 사용할 수 있는 옵션
 */

const transformToSelectOption = <T extends Record<string, unknown>, V extends string | number = string>(
  option: T,
  valueKey: keyof T,
  textKey: keyof T,
  textFormatter?: (value: V, text: string) => string
): TypeSelectOption<V> | null => {
  if (!option) return null;

  return {
    value: option[valueKey] as V,
    text: textFormatter ? textFormatter(option[valueKey] as V, String(option[textKey])) : String(option[textKey]),
  };
};

export default transformToSelectOption;
